import React from "react";
import { Spinner } from "react-bootstrap";

export default function ShowSpinner() {
  return <Spinner animation="grow" variant="light" />;
}
